import { useQuery } from '@apollo/client';
import {
  Disclaimer,
  Headlines,
  Loading,
  Map,
  SuburbSpotlight,
  TotalProducts
} from 'components';
import Maintenance from 'components/Maintenance';
import { LocationProvider } from 'contexts/LocationContext';
import { GET_LOCATIONS_QUERY } from 'gql/query';
import {
  getLocationState,
  getLocationsSuburb,
  getSuburbSpotlights,
  getTotalProducts
} from 'utils/dashboard';

function App() {
  const { loading, error, data } = useQuery(GET_LOCATIONS_QUERY);
  const locations = data?.allActPublicLocationLevels?.nodes;

  if (loading) {
    return <Loading />;
  }

  if (error || !locations) {
    return <Maintenance />;
  }

  const locationsSuburb = getLocationsSuburb(locations);
  const locationState = getLocationState(locations);

  const suburbSpotlights =
    locationsSuburb && getSuburbSpotlights(locationsSuburb);
  const totalProducts = locationState && getTotalProducts(locationState);
  const lastUpdatedAt = locations[0].lastUpdatedAt;

  return (
    <div className="container" id="act-dashboard-brighte">
      <div>{locationState && <Headlines location={locationState} />}</div>

      <LocationProvider>
        {suburbSpotlights && lastUpdatedAt && (
          <SuburbSpotlight
            spotlights={suburbSpotlights}
            lastUpdatedAt={lastUpdatedAt}
          />
        )}
        {locationsSuburb && <Map locations={locationsSuburb} />}
        {totalProducts && <TotalProducts totalProducts={totalProducts} />}
        {lastUpdatedAt && <Disclaimer lastUpdatedAt={lastUpdatedAt} />}
      </LocationProvider>
    </div>
  );
}

export default App;
